import ErrorText from '@components/shared/ErrorText';
import clsx from 'clsx';
import phone from 'phone';
import PropTypes from 'prop-types';
import PhoneInput from 'react-phone-input-2';

import { addPlusSign } from '@shared/helpers';
import { useState } from 'react';
import { Controller } from 'react-hook-form';

import 'react-phone-input-2/lib/style.css';
import styles from './PhoneNumberInput.module.scss';

const PhoneNumberInput = ({ defaultValue, control, error, autofocus }) => {
  const inputStyle = clsx({
    [styles.inputStyle]: true,
    [styles.errorInput]: !!error,
  });

  const [isValidPhone, setIsValidPhone] = useState();

  return (
    <div className={styles.container}>
      <Controller
        control={control}
        defaultValue={defaultValue}
        name='phone'
        rules={{
          required: {
            value: true,
            message: 'Please enter a mobile phone number',
          },
          validate: () => (!isValidPhone ? 'Invalid phone number' : null),
        }}
        render={({ field: { onChange: setValue, value, ref } }) => (
          <>
            <PhoneInput
              country='us'
              placeholder={'Number'}
              isValid
              value={value}
              onMount={(val, country) => {
                const { isValid } = phone(val, {
                  country: country.countryCode.toUpperCase(),
                });
                setIsValidPhone(isValid);
              }}
              onChange={(val, country) => {
                if (val && country) {
                  const { isValid } = phone(val, {
                    country: country.countryCode.toUpperCase(),
                  });
                  setIsValidPhone(isValid);
                }
                setValue(addPlusSign(val));
              }}
              inputProps={{
                autoFocus: autofocus,
                ref,
              }}
              inputClass={inputStyle}
              buttonClass={styles.buttonStyle}
              enableSearch
              disableSearchIcon
            />
            {!value && <span className={styles.required}> *</span>}
          </>
        )}
      />
      {error && (
        <ErrorText customStyle={styles.error}>{error?.message}</ErrorText>
      )}
    </div>
  );
};

PhoneNumberInput.propTypes = {
  control: PropTypes.object,
  error: PropTypes.shape({
    message: PropTypes.string,
  }),
  defaultValue: PropTypes.string,
  autofocus: PropTypes.bool,
};

export default PhoneNumberInput;
